import React from 'react';
import RichText from 'modules/common/components/RichText';

const BillRichText = ({ label, name, value, readOnly, onChange }) => {
  return (
    <div className="ui segment">
      <div className="ui field">
        <label>{label}</label>
        <RichText value={value || ''} readOnly={readOnly} onChange={onChange} />
        <input type="hidden" name={name} value={value} />
      </div>
    </div>
  );
};

export default BillRichText;



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/BillRichText.js